// src/serviceWorkerRegistration.js

let refreshing = false;

export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // console.log("[SW] Registrado:", registration);

          // NÃO forçar skipWaiting automaticamente.
          // Deixe o novo SW em "waiting" até recarregar essa aba
          // ou até você chamar manualmente (exportado abaixo).

          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                // console.log("[SW] Nova versão disponível (aplicará no próximo reload desta aba).");
              }
            });
          });

          // Se o SW assumir o controle desta aba, recarrega apenas se ela estiver visível
          navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (refreshing) return;
            if (document.visibilityState !== "visible") return;
            refreshing = true;
            window.location.reload();
          });
        })
        .catch((err) => {
          console.error("[SW] Falha no registro:", err);
        });
    });
  }
}

// Caso você queira um botão “Atualizar agora” em algum lugar do app:
export async function forceUpdate() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (reg && reg.waiting) {
    reg.waiting.postMessage({ type: "SKIP_WAITING" });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch((err) => console.error(err));
  }
}
